export const getIdsSearchParam = (id: string, searchParamIds: string | undefined, acceptSlice: boolean = true) => {
  const searchParamIdsArr = searchParamIds?.split(",") || [];
  const searchParamIdsEntityIndex = searchParamIdsArr?.findIndex((paramId) => paramId === id);

  if (searchParamIdsEntityIndex === -1) {
    return [...searchParamIdsArr, id];
  }

  if (acceptSlice) {
    return [
      ...searchParamIdsArr.slice(0, searchParamIdsEntityIndex),
      ...searchParamIdsArr.slice(searchParamIdsEntityIndex + 1),
    ];
  }

  return searchParamIdsArr;
};

export const getSearchParamsWithIdsParam = (
  id: string,
  paramName: string,
  params: Record<string, string>,
  acceptSlice: boolean = true
) => {
  const searchParamIds = params[paramName] || undefined;
  const entityIdsParamValue = getIdsSearchParam(id, searchParamIds, acceptSlice).join(",");
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { [paramName]: _, ...otherParams } = params;

  if (entityIdsParamValue) {
    return { ...otherParams, [paramName]: entityIdsParamValue };
  }

  if (searchParamIds) {
    return otherParams;
  }

  return null;
};
